import React from 'react';
import './footer.css';
import Facebook from '../../svg/Facebook';
import Instagram from '../../svg/Instagram';
import WhatsApp from '../../svg/WhatsApp';
import LinkedIn from '../../svg/LinkedIn';
import GitHub from '../../svg/GitHub';

function Footer() {

    return (
        <div className="footer">
            <div className="footer-start">
                <div className="footer-middle-container">
                    <h1>Get in touch with me</h1>
                    <div className="footer-social">
                            <div className="social-flex">
                                <a href="https://www.facebook.com/profile.php?id=100004838256907" target="_blank" rel="noreferrer">
                                    <Facebook className={"i"} />
                                </a>
                        
                                <a href="https://www.instagram.com/ashishgupta9394/" target="_blank" rel="noreferrer">
                                    <Instagram className={"i"} />
                                </a>
                        
                                <a href="https://wa.me/+91 8689868867" rel="noreferrer">
                                    <WhatsApp className={"i"} />
                                </a>

                                <a href="https://www.linkedin.com/in/ashish-gupta8689" target="_blank" rel="noreferrer">
                                    <LinkedIn className={"i"} />
                                </a>

                                <a href="https://github.com/Ashish8689" target="_blank" rel="noreferrer">
                                    <GitHub className={"i"} />
                                </a>

                            </div>{/* social flex end */}
                    </div> {/* footer-socialend */}
                </div> {/* footer-middle-contaier end */}
            </div> {/* footer start end */}
            

            <div className="footer-end">
                <p>Copyright 2021 © All Rights Reserved. Made by <a href="https://www.instagram.com/ashishgupta9394" target="_blank" rel="noreferrer"> Ashish Gupta</a>
                </p>
            </div>
        </div>
    )
}

export default Footer
